import { TranslationService } from './../core/services/translation.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import { environment } from '../../environments/environment';
import { APP_TITLE_KEY } from '../dashboard/dashboard.component';

const iphoneUrl = `itms-services://?action=download-manifest&url=${ environment.downloadUrl }ios/manifest.plist`;
const androidUrl = `${ environment.downloadUrl }android/${ environment.androidAPK }`;

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {
  descriptionParams: { [key: string]: any };
  url: any;
  isIos: boolean;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private translationService: TranslationService,
    private titlesService: Title
  ) {}

  ngOnInit() {
    this.isIos = (this.route.snapshot.params['appType'] === 'iphone');
    this.descriptionParams = { appDescription: (this.isIos) ? 'iPhone' : 'Android' };
    this.url = this.sanitizer.bypassSecurityTrustUrl((this.isIos) ? iphoneUrl : androidUrl);
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.titlesService.setTitle(title);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/download/download.component.ts